import React from 'react';
import { ActivityIcon, CircleCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroChecks, heroDescription, heroImage, price, productName } from '../data/copy';

/**
 * Mobile budget: badge, headline, mockup and the CTA all fit in the first
 * screen (~600px). Supporting copy sits under the button.
 */
export function Hero() {
  return <header className="w-full border-b border-line bg-white" data-id="element-128" data-mp="4jvyzk2o7p0h">
      <div className="mx-auto max-w-4xl px-5 pb-10 pt-4 text-center sm:px-6 sm:pb-16 sm:pt-12" data-id="element-129" data-mp="128yysajftrxl">
        <p className="inline-flex items-center gap-1.5 rounded-full border border-gold/60 bg-gold-tint px-3 py-1 text-[11px] font-semibold text-navy sm:gap-2 sm:px-4 sm:py-1.5 sm:text-sm" data-id="element-130" data-mp="xaxfppm0hsm4">
          <ActivityIcon className="h-3.5 w-3.5 text-gold-text sm:h-4 sm:w-4" strokeWidth={2.5} aria-hidden="true" data-id="element-131" data-mp="nbexbdlr2ew6" />
          {productName}
        </p>

        <h1 className="mx-auto mt-2.5 max-w-3xl font-display text-[1.8rem] font-bold leading-[1.1] text-navy sm:mt-5 sm:text-5xl lg:text-6xl" data-id="element-132" data-mp="382fgbrjt9agi">
          Stop Improvising.{' '}
          <span className="text-gold-text" data-id="element-133" data-mp="3j6fxfnpbn9cs">Start Coaching.</span>
        </h1>
        <p className="mx-auto mt-1.5 max-w-2xl text-sm font-semibold text-navy sm:mt-4 sm:text-xl" data-id="element-134" data-mp="3o73na61tdk5f">
          Build your championship season in minutes, not hours.
        </p>

        {/* The mockup sits directly under the promise (headline). */}
        <img src={heroImage} alt="The Coach’s Operating System™: master box, 6 volumes, coaching dashboard on tablet and 5 command kit bonuses." className="mx-auto -mb-1 mt-1 w-full max-w-[290px] sm:mb-0 sm:mt-6 sm:max-w-xl lg:max-w-2xl" width={1254} height={1254} decoding="sync" loading="eager" {...{
        fetchpriority: 'high'
      }} data-id="element-135" data-mp="30i15my76jrax" />

        <p className="mx-auto mt-2 max-w-2xl text-xs leading-relaxed text-body sm:mt-6 sm:text-lg" data-id="element-136" data-mp="2vjq0h0rty4z1">
          <span className="sm:hidden" data-id="element-137" data-mp="2hkgh5s8buuqu">
            150+ ready-to-run sessions for sprints, jumps, throws and distance —
            organized from beginner to advanced.
          </span>
          <span className="hidden sm:inline" data-id="element-138" data-mp="s3349bcaykwh">{heroDescription}</span>
        </p>

        <div className="mt-3 sm:mt-8" data-id="element-139" data-mp="nat6xa8uyik6">
          <CtaButton size="large" className="w-full sm:w-auto" data-id="element-140" data-mp="n9qkpfmhd4al">
            <span className="sm:hidden" data-id="element-141" data-mp="ibgn6yda9rlt">Get the system now</span>
            <span className="hidden sm:inline" data-id="element-142" data-mp="i9vuleaj4iql">
              Get the complete coaching system now
            </span>
          </CtaButton>
          <p className="mt-2 text-xs text-body sm:mt-3 sm:text-sm" data-id="element-143" data-mp="1b15lv52itfk9">
            One-time payment · 7-Day Guarantee
          </p>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1.5 sm:mt-5 sm:gap-x-5" data-id="element-144" data-mp="15zq2dhfzrh3z">
          {heroChecks.map(item => <li key={item} className="flex items-center gap-1.5 text-xs text-body sm:text-sm" data-id="element-145" data-mp="x14nbw9qak7y">
              <CircleCheckIcon className="h-4 w-4 text-success" strokeWidth={2.25} aria-hidden="true" data-id="element-146" data-mp="3lsyrwwxreii0" />
              {item}
            </li>)}
        </ul>
      </div>
    </header>;
}